//@ts-nocheck

interface CreateInvoiceTypes {
  order?: any | any[];
  totalPrice?: number;
  email?: string;
  fullName?: string;
  phoneNumber?: string;
  description?: string;
  teamId?: string;
  selectedTime?: any;
  date?: any;
  duration?: number;
  user_id?: string;
  selectedEndTime?: any;
  selectedService?: string;
  productIds?: number[];
  voucherId?: number;
  to_user_id?: string;
  delivery_date?: string | null;
  service_ids?: any;
  booked_times?: any;
  shipping_address_id?: number;
  home_location?: any;
  record_id?: number;
  salonId?: any;
  messageVaucher?: string;
  order_id_vaucher?: string;
}

function safeParseJson(input: any) {
  if (typeof input === 'string') {
    return input;
  }

  if (typeof input === 'object' && input !== null) {
    return input.client_url || input.url || null;
  }

  return null;
}

export const createInvoice = async ({
  order,
  totalPrice,
  email,
  fullName,
  user_id,
  phoneNumber,
  description,
  teamId,
  selectedTime,
  date,
  duration,
  selectedEndTime,
  selectedService,
  productIds,
  voucherId,
  to_user_id,
  delivery_date,
  service_ids,
  booked_times,
  shipping_address_id,
  home_location,
  record_id,
  salonId,
  messageVaucher,
  order_id_vaucher,
}: CreateInvoiceTypes) => {
  const orderIds = order_id_vaucher
    ? [order_id_vaucher]
    : order === 'Booking'
    ? 'Booking'
    : order?.map(o => o.order_id);
  console.log('orderids', orderIds, order_id_vaucher);
  const req = await fetch('https://gibnkggiuxphkienkxwf.supabase.co/functions/v1/create-invoice', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdpYm5rZ2dpdXhwaGtpZW5reHdmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA3OTI0OTEsImV4cCI6MjA0NjM2ODQ5MX0.jzHj8vjuo7KuX4nHi-_tq051mp9quUNKMP0wN8Makj4`, // Замените YOUR_ACCESS_TOKEN на ваш токен
    },
    body: JSON.stringify({
      amount_cents: totalPrice,
      payment_methods: [7086, 7085, 23967],
      email,
      is_live: true,
      full_name: fullName,
      phone_number: phoneNumber,
      description,
      order_ids: orderIds,
      teamId: teamId ? teamId : '',
      selectedTime: selectedTime ? selectedTime : '',
      date: date ? date : '',
      duration: duration ? duration : '',
      user_id: user_id ? user_id : '',
      selectedEndTime: selectedEndTime ? selectedEndTime : '',
      selectedService: selectedService ? selectedService : '',
      productIds,
      voucherId,
      to_user_id,
      delivery_date,
      service_ids,
      booked_times,
      shipping_address_id,
      home_location,
      record_id,
      salonId,
      messageVaucher,
    }),
  });

  let response: any;

  try {
    const body = await req.json();
    response = safeParseJson(body);
  } catch (e) {
    console.error('Failed to parse JSON response:', e);
    response = null;
  }

  return response;
};
